import { render, staticRenderFns } from "./ImageGallerySlider.vue?vue&type=template&id=95f2b3ec&scoped=true&"
import script from "./ImageGallerySlider.vue?vue&type=script&lang=js&"
export * from "./ImageGallerySlider.vue?vue&type=script&lang=js&"
import style0 from "./ImageGallerySlider.vue?vue&type=style&index=0&id=95f2b3ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f2b3ec",
  null
  
)

export default component.exports